import { FC } from 'react'
import { times } from 'lodash'
import { CheckIcon } from 'lucide-react'
import { useAppSelector } from '../../../../redux'
import { StyledCoursePreviewLearn } from '.'

const CoursePreviewLearn: FC = () => {
  const { course, loading } = useAppSelector((state) => state.course)

  return (
    <StyledCoursePreviewLearn $loading={loading}>
      <div className="width-controller">
        <div className="section-content">
          <h2>What you’ll learn</h2>
          <ul>
            {!loading &&
              course?.offeringsDescription.map((point) => {
                return (
                  <li key={point}>
                    <CheckIcon />
                    {point}
                  </li>
                )
              })}
            {loading &&
              times(3, (index) => {
                return (
                  <li key={index}>
                    <div />
                  </li>
                )
              })}
          </ul>
        </div>
      </div>
    </StyledCoursePreviewLearn>
  )
}

export default CoursePreviewLearn
